import Icons from '../../components/Icons';
import { PaymentMethodTypes } from '../../components/PaymentCaptureMethod/constants.ts';

const getPaymentIcon = (paymentType, cardType) => {
  const paymentTypeMap = {
    [PaymentMethodTypes.ApplePay]: Icons.applePay,
    [PaymentMethodTypes.GooglePay]: Icons.googlePay,
  };

  if (paymentTypeMap[paymentType]) {
    return paymentTypeMap[paymentType];
  }

  if (paymentType === PaymentMethodTypes.Card) {
    const cardLogo = Icons.cardLogos[cardType?.toLowerCase()];
    return cardLogo?.[1] || null; // [1] is the current card version
  }

  return null;
};

export default getPaymentIcon;
